<template>
  <div>
    <head-Back title="服务协议"></head-Back>
    <div class="arreement">
      <h3>服务协议</h3>
      <p class="desc">请仔细阅读以下条款，点击“勾选”即表示对相关条款的同意。</p>
      <p class="title_small">一、重要须知</p>
      <p class="desc">1、用户应认真阅读（未成年人应当在监护人陪同下阅读）、充分理解本协议中各条款。除非用户接受本协议，用户应当立即停止注册及使用行为。</p>
      <p class="desc">2、用户在进行注册程序过程中点击“同意”按钮即表示用户完全接受本协议项下的全部条款。（本应用注册即登录，下文注册本应用也代表登录本应用）</p>
      <p class="desc">3、用户注册成功后，本应用将给予每个用户一个用户帐号；登录时，用手机号和图形验证码登录即可。</p>
      <p class="title_small">二、服务内容</p>
      <p class="desc">1、本应用服务的具体内容由本应用根据实际情况提供。</p>
      <p
        class="desc"
      >2、用户同意本应用为本协议履行或相关研究的目的收集、使用或授权第三方（且该等第三方同意承担与本应用同等的个人信息保护义务） 非商业地使用通过服务获取的用户信息（包括但不限于身份信息、性别、职业、兴趣爱好、在本应用中形成的资料）， 包括但不限于使用于排行榜上，使本应用其他用户可以查看用户的头像、名字、语音等个人资料、应用于相关学术、应用研究等。 本应用承诺，除非另行取得用户的事先同意，否则本应用不会将用户信息授权给与履行本协议无关的第三方用于商业目的。</p>
      <p class="desc">3、根据相关法律法规及国家标准，在以下情形中，本应用可能会依法收集并使用用户的个人信息并且无需征得用户的同意:</p>
      <p class="desc">（1）与国家安全、国防安全直接相关的；</p>
      <p class="desc">（2）与公共安全、公共卫生、重大公共利益直接相关的；</p>
      <p class="desc">（3）与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
      <p class="desc">（4）出于维护用户或他人的生命、财产等重大合法权益但又很难得到用户本人同意的；</p>
      <p class="desc">（5）所收集的个人信息是用户自行向社会公众公开的；</p>
      <p class="desc">（6）从合法公开披露的信息中收集个人信息，例如：合法的新闻报道、政府信息公开等渠道；</p>
      <p class="desc">（7）根据用户的要求签订和履行合同所必需的；</p>
      <p class="desc">（8）用于维护所提供的服务的安全稳定运行所必需的，例如：发现、处置产品或服务的故障；</p>
      <p class="desc">（9）为合法的新闻报道所必需的；</p>
      <p class="desc">（10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</p>
      <p class="desc">（11）法律法规规定的其他情形。</p>
      <p class="desc">6、在以下情形中，本应用向第三方提供用户的个人信息无需事先征得用户的授权同意：</p>
      <p class="desc">（1）与国家安全、国防安全有关的；</p>
      <p class="desc">（2）与公共安全、公共卫生、重大公共利益有关的；</p>
      <p class="desc">（3）与犯罪侦查、起诉、审判和判决执行等有关的；</p>
      <p class="desc">（4）出于维护用户或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
      <p class="desc">（5）用户自行向社会公众公开的个人信息；</p>
      <p class="desc">（6）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</p>
      <p
        class="desc"
      >根据法律规定，向第三方提供经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的， 不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向用户通知并征得用户的同意。</p>
      <p class="title_small">本协议中涉及本应用对于用户提供的个人信息的使用，如与《隐私政策》不符的，以《隐私政策》为准。</p>
      <p class="title_small">三、用户使用规则</p>
      <p class="desc">1、用户注册成功后，用户有权使用本应用软件功能与用户进行分享交流。</p>
      <p class="desc">2、用户有权使用本应用提供的个人主页、照片上传、分享个人信息。</p>
      <p class="desc">3、用户在使用本应用时须遵守国家相关法律法规，内容不得包含有下列内容之一的信息：</p>
      <p class="desc">a) 反对宪法所确定的基本原则的；</p>
      <p class="desc">b) 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
      <p class="desc">c) 损害国家荣誉和利益的；</p>
      <p class="desc">d) 煽动民族仇恨、民族歧视、破坏民族团结的；</p>
      <p class="desc">e) 破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
      <p class="desc">f) 散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
      <p class="desc">g) 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p>
      <p class="desc">h) 侮辱或者诽谤他人，侵害他人合法权利的；</p>
      <p class="desc">i) 含有虚假、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、猥亵、或其它道德上令人反感的内容；</p>
      <p class="desc">j) 含有中国法律、法规、规章、条例以及任何具有法律效力之规范所限制或禁止的其它内容的；</p>
      <p class="desc">k) 含有本应用认为不利于本应用运营的内容。</p>
      <p
        class="desc"
      >4、用户必须清楚使用规则，本应用仅供个人交流、学习欣赏，非商业性质的使用，用户不可利用本服务对信息或表演等知识产权内容进行出售、或利用本服务进行调查、广告、或用于其他商业目的。</p>
      <p class="desc">5、 用户保证在使用本应用时发布、传播的信息的真实性、准确性，保证不得发布谣言或其他与事实不符引起他人不适的言论、信息。</p>
      <p
        class="desc"
      >6、用户保证在使用本应用不得发布、传播侵犯知识产权或其他合法权益的信息。 用户传播内容中涉及第三方拥有知识产权内容的相关授权或其他内容的合法性由用户自行负责， 本应用对相关内容的知识产权权属或是否侵犯他人民事权益等情况不进行审查或监督，但将按相关法规对涉嫌侵权的内容履行删除或断开链接等职责。</p>
      <p
        class="desc"
      >7、若用户发生前述3-6的行为时，由用户承担所有的违法、侵权责任，若因此给本应用造成任何损失本应用有权向责任用户主张相关责任。 同时，本应用有权对违法、侵权、违规的用户终止提供服务。如果政府或者司法机关要求本应用告知进行侵权行为用户的具体信息的，本应用有权根据现行法规向其告知用户信息。</p>
      <p
        class="desc"
      >8、用户同意本应用有权在提供服务过程中以各种方式投放各种商业性广告或其他任何类型的商业信息，并且，用户同意接受本应用通过电子邮件或其他方式向用户发送商品促销或其他相关商业信息。</p>
      <p class="title_small">四、知识产权</p>
      <p class="desc">1、用户在使用本应用分享个人作品或者演绎他人作品时，不得侵犯第三方任何知识产权。</p>
      <p
        class="desc"
      >2、用户使用本应用分享信息中含有的完全由用户自身原创信息的版权归用户，但其中利用本应用而形成的录音或其他资料， 利用本应用中已有素材而形成的录音或其他资料的版权由用户与本应用共有。 用户的分享行为是对其享有版权或经合法授权的相关内容的网络传播行为许可，用户的分享行为即表明其已授权本应用及其他用户有权复制、传播前述信息。</p>
      <p class="title_small">五、服务变更、中断或终止</p>
      <p
        class="desc"
      >1、鉴于服务的特殊性，用户同意本应用有权随时变更、中断或终止部分或全部的服务。 如变更、中断或终止的服务属于免费服务，本应用无需通知用户，也无需对任何用户或任何第三方承担任何责任；</p>
      <p class="desc">2、用户理解，本应用需要定期或不定期地对提供服务的平台或相关的设备进行检修或者维护。</p>
      <p class="desc">3、如发生下列任何一种情形，本应用有权随时中断或终止向用户提供本协议项下的服务：</p>
      <p class="desc">a) 用户提供的个人资料不真实；</p>
      <p class="desc">b) 用户违反本协议中规定的使用规则；</p>
      <p class="desc">c) 出现自然灾害等不可抗力导致本应用无法运营的。</p>
      <p
        class="desc"
      >4、用户注册的免费帐号昵称如存在违反法律法规、国家政策要求、本应用的昵称管理要求，或侵犯任何第三方合法权益的情况，本应用有权要求用户进行修改或收回该账号昵称。</p>
      <p class="title_small">六、其他事宜</p>
      <p
        class="desc"
      >1、本应用有权根据法律法规的变化、网站以及相应的本应用运营的需要不时地对本协议及本站的内容进行修改, 并在网站以及本应用醒目位置张贴。修改后的协议一旦被张贴在本站上即生效,并代替原来的协议,用户可随时登录查阅最新协议。 用户有义务及时关注并阅读最新版的协议及网站公告。如用户不同意更新后的协议,可以立即向本应用进行反馈且应立即停止接受本应用依据本协议提供的服务; 如用户继续使用本站提供的服务的,即视为同意更新后的协议。</p>
      <p class="desc">2、本协议自用户点击“同意”、“接受”后生效。</p>
      <p class="desc">3、本协议所有条款的标题仅为方便而设,不具法律或契约效果。</p>

      <p class="desc-com">单词乐运营团队</p>

    </div>
  </div>
</template>
<script>
import headBack from "../common/head-back-close";
import store from "@/store";

export default {
  name: "app",
  data() {
    return {
      msg: "服务协议"
    };
  },

  mounted() {
    this.$point.init(new Date());
    store.dispatch("hideLoading");
  },

  components: {
    headBack
  }
};
</script>
<style  scoped>
#app {
  width: 750px;
  height: 1334px;
}

.arreement {
  padding: 32px 58px 80px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(48, 48, 48, 1);
  line-height: 40px;
}

.arreement h3 {
  width: 610px;
  height: 50px;
  font-size: 36px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 600;
  color: rgba(48, 48, 48, 1);
  line-height: 50px;
}
.arreement p {
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(48, 48, 48, 1);
  line-height: 40px;
  text-align: left;
}
.arreement .arreement .title {
  text-align: left;
  padding-bottom: 30px;
  font-weight: bold;
  font-size: 32px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 500;
  color: rgba(48, 48, 48, 1);
  line-height: 44px;
}
.arreement .title_small {
  padding-top: 20px;
  line-height: 26px;
}

.arreement span {
  color: red;
  text-decoration: underline red;
}

.arreement .bold {
  font-weight: bold;
}
.arreement .text_line {
  text-decoration: underline;
}
.desc-com{
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/agreement/privacyAgreexxl2.vue